import React, { useState, useEffect, useRef } from "react";
import {
    Button,
    Header,
    Textarea,
    Container,
    SpaceBetween,
    Box,
    Grid,
    Link,
    ExpandableSection,
    FileUpload,
    Modal,
    Spinner,
    Checkbox,
    ColumnLayout,
    Select,
    Tabs,
    Input,
    TokenGroup
} from "@amzn/awsui-components-react";
import './styles.scss'
import { useSuggestedLogins } from "src/hooks/useSuggestedLogins";

const TANCPermissionManager = (props) => {
    var [rows, setRows] = useState(props.getValues() || []);
    var [errorMessage, setErrorMessage] = useState('');
    const [existingSchema, setExistingSchema] = useState({});
    const { suggestedLogins, aliasesLoading, getSuggestedLoginsCaller } = useSuggestedLogins();
    const [roles, setRoles] = useState([
        { label: "VIEWER", value: "VIEWER" },
        { label: "EDITOR", value: "EDITOR" },
        { label: "ADMIN", value: "ADMIN" },
    ])

    const aliases = [
        { label: "USER", value: "USER" },
        { label: "LDAP", value: "LDAP" }
    ]


    useEffect(() => {
        loadRows()
        return () => {
        };
    }, []);

    useEffect(() => {
        if (props.associationType == 'FLEXICO') {
            setRoles([
                { label: "VIEWER", value: "VIEWER" },
                { label: "EDITOR", value: "EDITOR" },
                { label: "REVIEWER", value: "REVIEWER" },
                { label: "ADMIN", value: "ADMIN" },
            ])
        }
        return () => {
        };
    }, [props]);

    useEffect(() => {
        loadRows()
        return () => {
        };
    }, [props?.reloadNotifiers]);


    useEffect(() => {
        if (isInValid()) {
            let msg = ''
            if (props?.errorMessage) {
                msg = props?.errorMessage
            }
            setErrorMessage(msg)
        } else {
            setErrorMessage('')
            props.updateValue(getMergedInputValues())
        }
    }, [rows])

    const getMergedInputValues = () => {
        var filtered = rows?.filter(function (row) {
            return row != null;
        });
        return filtered
    }

    const isInValid = () => {
        return props.validator && !props.validator(getMergedInputValues())
    }

    const onEdit = (value, index, key) => {
        rows[index][key] = value
        setRows([...rows])
    }

    function getFilterLabel(filterId) {
        for (let i = 0; i < props?.filters?.length; i++) {
            if (props.filters[i].value == filterId) {
                return props.filters[i].label
            }
        }
    }

    function makeSelectObject(value) {
        if (value === null || value === '') {
            return null
        } else {
            return { label: value, value: value }
        }
    }


    const getInputItem = (value, index) => {
        return <div className='rows' key={index}>
            <Container>
                <SpaceBetween direction="horizontal" size="xxl" key={index}>
                    <SpaceBetween direction="vertical">
                        <Box variant="h4">Type</Box>
                        <Select
                            selectedOption={value && value[props.typeKey] ? { value: value[props.typeKey] } : null}
                            onChange={({ detail }) =>
                                onEdit(detail.selectedOption.value, index, props.typeKey)
                            }
                            options={aliases}
                            placeholder="Choose alias type"
                        />
                    </SpaceBetween>

                    <SpaceBetween direction="vertical">
                        <Box variant="h4">Alias</Box>
                        {
                            value?.[props.typeKey] == 'USER' ?
                                <Select
                                    selectedOption={makeSelectObject(value?.[props?.aliasKey])}
                                    onChange={({ detail }) => {
                                        onEdit(detail?.selectedOption?.value, index, props.aliasKey)
                                    }

                                    }
                                    placeholder="Select Alias"
                                    loadingText="Loading aliases"
                                    statusType={aliasesLoading ? "loading" : "finished"}
                                    empty="No valid alias to recommend for entered text"
                                    options={suggestedLogins}
                                    filteringType="manual"
                                    onLoadItems={({ detail }) => {

                                        getSuggestedLoginsCaller(detail?.filteringText)

                                    }}
                                /> :
                                <Input
                                    onChange={({ detail }) => {
                                        let val = detail.value
                                        if (props?.postProcess) {
                                            val = props.postProcess(detail.value)
                                        }
                                        onEdit(val, index, props.aliasKey)
                                    }}
                                    placeholder={props.placeholder}
                                    value={value && value.hasOwnProperty(props.aliasKey) ? value[props.aliasKey] : ''}
                                />
                        }

                    </SpaceBetween>

                    <SpaceBetween direction="vertical">
                        <Box variant="h4">Role</Box>
                        <Select
                            selectedOption={value && value[props.roleKey] ? { value: value[props.roleKey] } : null}
                            onChange={({ detail }) =>
                                onEdit(detail.selectedOption.value, index, props.roleKey)
                            }
                            options={roles}
                        />
                        {
                            value?.[props?.roleKey] == 'REVIEWER' && <SpaceBetween>
                                <span className="info"> Reviewer will have an extra permission to 'Submit' after the edits are made by the editors </span>
                                <span className="info"> Recommended to add 'All' filter for the reviewer. Because, 'All' will be auto applied for the reviewer </span>
                            </SpaceBetween>
                        }
                    </SpaceBetween>

                    <SpaceBetween direction="vertical">
                        <Box variant="h4">Filter</Box>
                        <Select
                            selectedOption={value && value[props.filterKey] ? { label: getFilterLabel(value[props.filterKey]), value: value[props.filterKey] } : null}
                            onChange={({ detail }) =>
                                onEdit(detail.selectedOption.value, index, props.filterKey)
                            }
                            options={props?.filters}
                        />
                    </SpaceBetween>


                    <div className="row"><Button iconName="close" variant="icon" onClick={() => {
                        deleteRow(index)
                    }} />

                    </div>
                </SpaceBetween>
            </Container>
        </div>
    }

    const deleteRow = (index) => {
        rows.splice(index, 1)
        setRows([...rows])
    }

    const saveConfiguration = () => {
        props.notify({ 'ACTION': 'SAVE' })
    }

    const addNewRow = () => {
        addRow()
    }

    const addRow = (type = '', datatype = null) => {
        var newRow = {}
        newRow[props.aliasKey] = datatype
        newRow[props.typeKey] = type
        newRow[props.roleKey] = null
        newRow[props.filterKey] = null
        setRows([...rows, newRow])
    }

    const getActionButtons = () => {
        return <SpaceBetween direction="vertical" size="s">
            <SpaceBetween direction="horizontal" size="s">
                {
                props?.loadingMessage ? <SpaceBetween direction="horizontal" size="m">
                    <Spinner></Spinner>
                    <Box color={props.loadingMessage?.type == 'success' ? 'text-status-inactive' : 'text-status-error'}>{props.loadingMessage?.message}</Box>
                </SpaceBetween> : <></>
            }
                <Button onClick={addNewRow}>Add Permission</Button>
                <Button variant="primary" onClick={saveConfiguration} disabled={props.tancId == null}>Save</Button>
            </SpaceBetween>

        </SpaceBetween>
    }

    const loadRows = () => {
        let values = props.getValues()
        if (values == null) {
            return
        }
        setRows(JSON.parse(JSON.stringify(values)))
        if(values){
            let existingSchema = values?.map(item => item?.[props?.typeKey]).filter(item => item !== null);
            setExistingSchema(existingSchema)
        }
        
    }

    return (
        <SpaceBetween size="m">
            {
                props?.loadingMessage ? <SpaceBetween direction="horizontal" size="m">
                    <Spinner></Spinner>
                    <Box color={props.loadingMessage?.type == 'success' ? 'text-status-inactive' : 'text-status-error'}>{props.loadingMessage?.message}</Box>
                </SpaceBetween> : <></>
            }
            {props.info && props.info != ' ' && props.info != '' ? <><span className="info">{props.info}</span> <br></br> </> : ''}
            {errorMessage && errorMessage != '' ? <><span className="error"> {errorMessage} </span><br></br></> : ''}
            {rows ? (Array.from(rows).map((value, index) => {
                return getInputItem(value, index);
            })) : ''}
            <Box float="right">
                {
                    getActionButtons()
                }
            </Box>
        </SpaceBetween>
    )
}

export default TANCPermissionManager;
